import React from "react";
import { storyblokEditable } from "@storyblok/react";

const ServiceTextFiftyFifty = ({ blok }) => (
  <div className="wrap">
    <div
      className="servicetextfiftyfifty-wrap inner-wrap"
      {...storyblokEditable(blok)}
    >
      <div className="servicetextfiftyfifty-text">
        <h2 className="text-2xl merriweather">{blok.subheadline1}</h2>
        <p>{blok.infotext1}</p>
      </div>
      <div className="servicetextfiftyfifty-text">
        <h2 className="text-2xl merriweather">{blok.subheadline2}</h2>
        <p>{blok.infotext2}</p>
      </div>
    </div>
  </div>
);

export default ServiceTextFiftyFifty;
